<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex bodyWrapper">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view" v-if="dataReady">
          <breadcrumb :crumb="name"></breadcrumb>
          <div class="intro-wrapper main-x-spacing">
            <h2>{{ title }}</h2>
            <v-row>
              <v-col cols="8">
                <v-text-field
                  v-model="searchQuery"
                  prepend-inner-icon="search"
                  label="Search Discounts"
                  class="toWhite"
                  flat
                  hide-details
                  single-line
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="2" v-if="userType > 8">
                <v-btn
                  :ripple="false"
                  @click="openAddDiscount"
                  depressed
                  style="min-width: 100px; max-width: 100%"
                  class="gen-button white--text flex-grow-1 flex-shrink-0"
                  color="#60a45f"
                >
                  <v-icon>add</v-icon>
                  <span>Add New Discount</span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row>
              <v-col cols="12">
                <div class="table-menu">
                  <v-data-table
                    :headers="headers"
                    :items="filteredSearchResult"
                    item-key="id"
                    class="elevation-0 dataTableUI staffTable border-me-light"
                  >
                    <!-- For Names -->
                    <template v-slot:item.name="{ item }">
                      {{ item.name }}
                    </template>

                    <!-- For Rate -->
                    <template v-slot:item.rate="{ item }">
                      {{ item.rate }}
                    </template>

                    <!-- For Type -->
                    <template v-slot:item.discountType="{ item }">
                      <span>{{
                        item.discountType == 1 ? "Percentage" : "Fixed"
                      }}</span>
                    </template>

                    <!-- For Actions -->
                    <template v-slot:item.action="{ item }" v-if="userType > 8">
                      <v-btn
                        :ripple="false"
                        x-small
                        text
                        class="white py-4 btn-outlined"
                        @click="openAddDiscount('edit', item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <span class="mx-2"></span>
                      <v-btn
                        text
                        class="white py-4 btn-outlined"
                        :ripple="false"
                        @click="deleteDiscount(item.id)"
                        ><v-icon>delete_forever</v-icon></v-btn
                      >
                    </template>
                  </v-data-table>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- Upload List -->
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Add New Discounts -->
                <div v-if="addNewDiscountActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Menu Item Discount</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <div class="form-group">
                      <v-row>
                        <v-col cols="12">
                          <div>Discount Name</div>
                          <v-text-field
                            v-model="discountName"
                            :rules="[rules.required]"
                            hide-details
                            height="25"
                            outlined
                            dense
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <div>Type</div>
                          <v-select
                            v-model="discountType"
                            :rules="[rules.required]"
                            :menu-props="{ offsetY: true }"
                            height="25"
                            flat
                            hide-details
                            outlined
                            dense
                            :items="discountOption"
                            offset-y
                            item-text="name"
                            item-value="value"
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <div>Rate</div>
                          <v-text-field
                            v-model="discountRate"
                            :rules="[rules.required, rules.number]"
                            height="25"
                            outlined
                            dense
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-form>
                  <div class="dialogAction text-right">
                    <v-btn
                      depressed
                      @click="
                        openDialog = false;
                        addNewDiscountActive = false;
                      "
                      class="btn-outlined grey--text mr-3"
                    >
                      Close
                    </v-btn>
                    <v-btn
                      depressed
                      class="btn-outlined success"
                      :loading="loader"
                      @click="addNewDiscount"
                    >
                      Ok
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <inner-page-loader v-else class="main-view"></inner-page-loader>
      </div>
    </div>
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import inner_page_loader from "@/components/innerPageLoader";
import { mapState } from "vuex";

import axios from "axios";

export default {
  data() {
    return {
      title: "Discounts",
      dataReady: false,
      loader: false,
      editMode: false,
      editedDiscountData: {},
      name: "",
      openDialog: false,
      currentSwitchTab: "",
      headers: [
        {
          text: "Discount Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: "Rate",
          align: "start",
          sortable: true,
          value: "rate",
        },
        {
          text: "Type",
          align: "start",
          sortable: true,
          value: "discountType",
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action",
        },
      ],
      currentDiscount: {},
      discountName: "",
      discountType: "",
      discountRate: "",
      discountOption: [
        { name: "Percentage", value: 1 },
        { name: "Fixed", value: 2 },
      ],
      addNewDiscountActive: false,
      rules: {
        required: (value) => !!value || "Required",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
      },
      searchQuery: "",
    };
  },
  methods: {
    openAddDiscount(edit, data) {
      this.addNewDiscountActive = true;
      this.openDialog = true;

      if (edit == "edit") {
        this.editMode = true;

        this.discountName = data.name;
        this.discountType = data.discountType;
        this.discountRate = data.rate;

        this.currentDiscount = data;
      }
    },
    addNewDiscount() {
      // Start Loader
      this.loader = true;

      let route;
      let reqType;
      let data = {
        name: this.discountName,
        discountType: this.discountType,
        rate: this.discountRate,
      };

      if (this.editMode == true) {
        route = "/api/v1/discount/order/" + this.currentDiscount.id;
        reqType = "put";
      } else {
        route = "/api/v1/discount/order";
        reqType = "post";
      }

      axios({
        method: reqType,
        url: route,
        headers: { Authorization: this.$store.state.token },
        data: data,
      })
        .then(() => {
          this.addNewDiscountActive = false;
          this.openDialog = false;

          this.loader = false;

          // Refresh cancellation discounts
          this.$store.dispatch("getAllDiscounts");
        })
        .catch(() => {
          this.loader = false;
        });
    },
    deleteDiscount(id) {
      axios
        .delete("/api/v1/discount/order/" + id, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          // Refresh cancellation Discounts
          this.$store.dispatch("getAllDiscounts");
        });
    },
  },
  watch: {
    allDiscounts(val) {
      if (val) {
        // stop page loader when data is ready
        this.dataReady = true;
      }
    },
    openDialog(val) {
      if (val == false) {
        // If openDialog is ever false, make editMode false
        this.editMode = false;

        this.$refs.dialogForm.reset();
        this.editMode = false; // VERY IMPORTANT: Always negate data after each edit request
      }
    },
  },
  created() {
    this.$store.dispatch("getAllDiscounts");
  },
  computed: {
    filteredSearchResult() {
      let grabArr = this.allDiscounts;

      return grabArr.filter((item) => {
        if (
          item.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) !== -1 // search by name
        ) {
          return item;
        }
      });
    },
    ...mapState(["mainNav", "allDiscounts", "userType"]),
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
    "inner-page-loader": inner_page_loader,
  },
};
</script>

<style scoped>
.table-menu {
  width: 96%;
  margin-left: 2%;
  margin-right: 2%;
}
.table-menu .table-col2 {
  width: 40%;
}

.image {
  width: 130px;
}

.item_status_icon {
  color: green;
}
</style>
